import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import { CancelHawkbitAction, CancelHawkbitActionVariables } from './__generated__/CancelHawkbitAction'

const CANCEL_HAWKBIT_ACTION = gql`
  mutation CancelHawkbitAction($input: CancelHawkbitActionInput!) {
    cancelHawkbitAction(input: $input) {
      success
    }
  }
`

export const useCancelHawkbitAction = () => {
  return useMutation<CancelHawkbitAction, CancelHawkbitActionVariables>(CANCEL_HAWKBIT_ACTION)
}
